import { AlertIcon, Modal } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { BaseSyntheticEvent } from 'react';

interface SignUpRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  isPending: boolean;
  onClickConfirm: (
    e?: BaseSyntheticEvent<object, any, any> | undefined,
  ) => Promise<void>;
}

export const SignUpRequestModal = (props: SignUpRequestModalProps) => {
  const { isOpen, onClose, isPending, onClickConfirm } = props;
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('signUpRequest.modal.label')}
      onClickConfirm={onClickConfirm}
      isLoadingConfirmBtn={isPending}
      labelBtnConfirm={t('signUpRequest.modal.confirm')}
      variantBtnConfirm="primary"
      labelBtnClose={t('common.cancel')}
      icon={AlertIcon}
      iconVariant="warning"
    />
  );
};

export default SignUpRequestModal;
